import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';

export const VocabularyForm = props => {
	const { initialValues } = props;
	const {
		control,
		formState: { errors },
		handleSubmit,
	} = useForm({
		defaultValues: initialValues,
	});

	return (
		<form onSubmit={handleSubmit(props.onSubmit)}>
			<Controller
				name="name"
				control={control}
				rules={{
					required: true,
					pattern: {
						value: /^[A-Za-z]+$/i,
						message: 'Может содержать только английские буквы',
					},
				}}
				defaultValue={null}
				render={({ field: { onChange, value } }) => (
					<TextField
						onChange={onChange}
						errorText={errors.name ? errors.name.message || 'Название для заполнения' : ''}
						floatingLabelText="Название"
						value={value}
						fullWidth={true}
						floatingLabelFixed={true}
					/>
				)}
			/>
			<Controller
				name="value"
				control={control}
				rules={{ required: true }}
				defaultValue={null}
				render={({ field: { onChange, value } }) => (
					<TextField
						onChange={onChange}
						errorText={errors.value ? 'Значение для заполнения' : ''}
						floatingLabelText="Значение"
						value={value}
						fullWidth
						floatingLabelFixed
					/>
				)}
			/>

			<Controller
				name="description"
				control={control}
				defaultValue={null}
				render={({ field: { onChange, value } }) => (
					<TextField
						onChange={onChange}
						value={value}
						hintText="Введите описание"
						multiLine
						rows={1}
						rowsMax={4}
						floatingLabelText="Описание"
						fullWidth
						floatingLabelFixed
					/>
				)}
			/>
			<div style={{ display: 'flex', marginTop: 20 }}>
				<RaisedButton label="Сохранить" type="submit" primary={true} />
				{props.children}
			</div>
		</form>
	);
};



// WEBPACK FOOTER //
// src/components/vocabulary/vocabulary-form.js